var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21 6.75H16.5V8.25H21V11.25H18V12.75H21V15.75H16.5V17.25H21C21.3977 17.2495 21.7789 17.0913 22.0601 16.8101C22.3413 16.5289 22.4995 16.1477 22.5 15.75V8.25C22.4995 7.85232 22.3414 7.47105 22.0602 7.18984C21.7789 6.90864 21.3977 6.75046 21 6.75Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 17.25H9V12.75C9.0004 12.3523 9.15856 11.971 9.43978 11.6898C9.721 11.4086 10.1023 11.2504 10.5 11.25H13.5V8.25H9V6.75H13.5C13.8977 6.75046 14.2789 6.90864 14.5602 7.18984C14.8414 7.47105 14.9995 7.85232 15 8.25V11.25C14.9995 11.6477 14.8414 12.029 14.5602 12.3102C14.2789 12.5914 13.8977 12.7495 13.5 12.75H10.5V15.75H15V17.25Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.25 6.75H1.5V8.25H3.75V15.75H1.5V17.25H7.5V15.75H5.25V6.75Z",
  fill: "currentColor"
});

var SvgLeiIcon = function SvgLeiIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeiIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LeiIcon.92144e68.svg";
export { ForwardRef as ReactComponent };